export default __webpack_public_path__ + "static/media/pumpkin2.d44a497f.png";